import { MessageNotificationService } from './../../services/message-notification.service';
import { Component, OnInit } from '@angular/core';
import { BuscaPromptService } from '../../services/busca-prompt/busca-prompt.service';
import { AvaliacoesPromptService } from '../../services/avaliacoes-prompt/avaliacoes-prompt.service';
import { MessageService } from 'primeng/api';
import { ERROR_MESSAGES, SUCCESS_MESSAGES } from '../../constants/validation-messages';

@Component({
    selector: 'app-prompt-database',
    templateUrl: './prompt-database.component.html',
    styleUrls: ['./prompt-database.component.css'],
    providers: [MessageService],
    standalone: false
})
export class PromptDatabaseComponent implements OnInit {
  prompt: any[] = [];
  expandedRows = {};
  isLoading = false;
  totalElements = 0;
  page = 0;
  size = 30;
  searchValue = '';
  pageSizes = [30, 50, 70, 90];
  sortField: string = '';
  sortDirection: string = 'asc';
  filterOptions = [
    { label: 'Título', value: 'title' },
    { label: 'Autor', value: 'autor' },
    { label: 'Descrição', value: 'description' },
    { label: 'Prompt', value: 'prompt' },
    { label: 'Palavra específica', value: 'word' },
    { label: 'Data', value: 'date' },
  ];
  selectedFilter: string = 'title';

  constructor(
    private buscaPromptService: BuscaPromptService,
    private avaliacoesPromptService: AvaliacoesPromptService,
    private messageService: MessageService,
    private MessageNotificationService: MessageNotificationService
  ) {}

  ngOnInit(): void {
    this.loadPrompts();
  }

  loadPrompts(): void {
    this.isLoading = true;
    const sort = `${this.selectedFilter},${this.sortDirection}`;
    this.buscaPromptService
      .searchPrompts(this.searchValue, this.page, this.size, sort)
      .subscribe({
        next: (response) => {
          this.prompt = response.data.content.map((prompt: any) => ({
            id: prompt.id,
            title: prompt.title,
            description: prompt.description,
            command: prompt.command,
            login: prompt.login,
            tags: prompt.tags
              ? prompt.tags
                  .split(',')
                  .map((tag: string) => tag.trim().replace(/^#/, ''))
              : [],
            totalAvaliacoes: prompt.review,
            mediaAvaliacao: prompt.average,
            anonymous: prompt.anonymous,
            version: prompt.version,
          }));
          this.totalElements = response.data.totalElements;
          this.isLoading = false;
        },
        error: (error) => {
          console.error('Erro ao buscar prompts:', error);
          this.isLoading = false;
        },
      });
  }

  onPageChange(event: any): void {
    this.page = event.first / event.rows;
    this.size = event.rows;
    this.loadPrompts();
  }

  onPageSizeChange(event: any): void {
    this.size = event.value;
    this.page = 0;
    this.loadPrompts();
  }

  onSearch(): void {
    this.page = 0;
    this.loadPrompts();
  }

  copiarTexto(texto: string): void {
    navigator.clipboard.writeText(texto).then(
      () => {
       this.MessageNotificationService.showSuccess(SUCCESS_MESSAGES.COMMAND_COPIED);
      },
      (err) => {
        console.error('Erro ao copiar comando:', err);
        this.MessageNotificationService.showError(ERROR_MESSAGES.COPY_COMMAND_FAILED);
      }
    );
  }

  onSortChange(field: string): void {
    if (this.sortField === field) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortField = field;
      this.sortDirection = field === 'average' ? 'desc' : 'asc';
    }
    this.prompt.sort((a: any, b: any) => {
      let valueA: any;
      let valueB: any;

      if (field === 'average') {
        valueA = a.mediaAvaliacao || 0;
        valueB = b.mediaAvaliacao || 0;
      } else {
        valueA = a[field]?.toLowerCase() || '';
        valueB = b[field]?.toLowerCase() || '';
      }

      if (valueA < valueB) return this.sortDirection === 'asc' ? -1 : 1;
      if (valueA > valueB) return this.sortDirection === 'asc' ? 1 : -1;
      return 0;
    });
  }
}
